import baseApi from "./baseApi";

const getAll = async () => {
    try {
        const response = baseApi.get('/projetos',{})
        return response
    } catch(error){
        return error;
    }
}

const create = async (form) => {
    try {
        const response = baseApi.post('/projetos', form)
        return response
    } catch(error){
        return error;
    }
}

const show = async (id) => {
    try {
        const response = baseApi.get('/projetos/' + id)
        return response
    }catch(error){
        return error
    }
}

const cadastrar_credores = async (value, classe, subclasse, id_projeto) =>{
    try {
        const response = baseApi.post('/credores', {
            name: value,
            classe: classe,
            subclasse: subclasse,
            id_projeto: id_projeto
        })
        return response
    }catch(error){
        return error
    }
} 

const busca_credores = async (id_projeto) =>{
    try {
        const response = baseApi.get('/credores/busca/' + id_projeto, {})
        return response
    }catch(error){
        return error
    }
} 

const credorUnico = async (id_credor) =>{
    try {
        const response = baseApi.get('/credores/' + id_credor, {})
        return response
    }catch(error){
        return error
    }
} 

const credorReck = (id_credor) =>{
    try {
        const response = baseApi.get('/credores/' + id_credor, {})
        return response
    }catch(error){
        return error
    }
} 



// reckValorOriginal.value, 
//         carencia.value, homologacao.value, inicioPagamento.value

const gerarFaturas = async (id_credor, parcela, data, valor, projeto, valorOrigianl, carencia, homologacao, desagio, taxa, tipo_parcela) =>{
    try {
        const response = baseApi.post('/credores/gerarFatura/' + id_credor, {
            id_projeto: projeto,
            id_credor: id_credor,
            valor_parcela: valor,
            inicio_parcela: data,
            quantidade_parcela: parcela,
            desagio: desagio,
            carencia: carencia,
            total_parcelas: parcela,
            taxa: taxa,
            homologacao: homologacao,
            valor_original: valorOrigianl,
            tipo_parcela:tipo_parcela

        })
        return response
    }catch(error){
        return error
    }
} 


const buscar_faturas = async (id_credor, id_projeto) =>{
    try {
        const response = baseApi.get(`/credores/parcelas/${id_credor}/${id_projeto}`, {})
        return response
    }catch(error){
        return error
    }
} 


const deletar_fatura = async (id) =>{
    try {
        const response = baseApi.delete(`/fatura/${id}`, {})
        return response
    }catch(error){
        return error
    }
} 

const fatura_paga = async (id, data_pagamento, valor_pagamento) =>{
    try {
        const response = baseApi.post(`/fatura/${id}`, {
                data_pagamento: data_pagamento,
                valor_pagamento: valor_pagamento
        })
        return response
    }catch(error){
        return error
    }
} 

const remove_credor = async (id, id_projeto) =>{
    try {
        const response = baseApi.delete(`/credor/remove/${id}/${id_projeto}`, {})
        return response
    }catch(error){
        return error
    }
} 

const deleteProjeto = async (id) => {
    try {
        const response = baseApi.delete('/projeto/' + id)
        return response
    }catch(error){
        return error
    }
}



// const updateClasse = async (id, nome) => {
//     try {
//         const response = baseApi.put('/classes/' + id, {
//                 name: nome
//         })
//         return response
//     }catch(error){
//         return error
//     }
// }

export default {
    getAll,
    create,
    credorReck,
    buscar_faturas,
    gerarFaturas,
    show,
    credorUnico,
    cadastrar_credores,
    busca_credores,
    deletar_fatura,
    fatura_paga,
    remove_credor,
    deleteProjeto,
}